/* global System */
// register component(s) with react habitat

export default { CategoryArchive: () => System.import('./data-component') }
